import { useGameMusic } from '@hooks/useGameMusic'
import { useGameSounds } from '@hooks/useGameSounds'
import { usePlayerSession } from '@hooks/usePlayerSession'
import { useSocketConnection } from '@hooks/useSocketConnection'
import { useState } from 'react'
import GameBootLoader from '../GameBootLoader'
import LayoutController from '@layouts/LayoutController'
import { useSelector } from 'react-redux'
import { useLoadConventions } from '@hooks/useLoadConventions'

const PlayZone = () => {
  usePlayerSession()
  useSocketConnection()
  useGameMusic()
  useGameSounds()

  const { brandId } = useSelector((state) => state.session.details)
  const { currencyCode } = useSelector((state) => state.wallet)

  useLoadConventions({ brand: brandId, currency: currencyCode })

  const [handedOff, setHandedOff] = useState(false)
  const { gameCode, theme } = useSelector((state) => state.launchParams.params)

  // The layout mounts immediately so the game canvas starts loading right away;
  // the boot loader is a full-screen overlay on top of it and hands off once
  // both auth and the canvas are ready (see GameBootLoader).
  return (
    <div className="play-zone-outer-container">
      <div className="play-zone-inner-container">
        <div className="play-zone-view-container">
          <LayoutController gameCode={gameCode} theme={theme} />
          {!handedOff && <GameBootLoader onComplete={() => setHandedOff(true)} />}
        </div>
      </div>
    </div>
  )
}

export default PlayZone
